// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* O painel de notificações virou React no redesign (JOR4-7365) e o estilo dele\n   está em menu-ds.css. Restou aqui o que pertence ao toast do DevExtreme, que\n   não faz parte do painel: as mensagens do Hermes trazem links, e sem esta regra\n   eles saem na cor padrão do toast, ilegível sobre o fundo escuro. */\n.dx-toast-info a {\n    color: lightgrey !important;\n}\n", ""]);
// Exports
module.exports = exports;
